import { C as Cart } from './cart-BEbKDMPu.js';
import { P as PubSub } from './pubsub-CoPYzvVm.js';
import { p as parseHTML } from './parseHTML-Om2c1Ayj.js';
import './uniq-BDEfcc0N.js';
import './notyf-DIw0RvBj.js';

class CartItemCount extends HTMLElement {
  #unsubscribers = [];

  static {
    Cart.sections.push('fetch-cart-item-count');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      ...['cart:add', 'cart:update', 'cart:change'].map((event) =>
        PubSub.subscribe(event, ({ sections }) => this.#renderSection(sections))
      )
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Add cart count
   */
  #renderSection(sections) {
    const html = parseHTML(sections['fetch-cart-item-count']);
    const target = html.querySelector('cart-item-count');
    this.replaceWith(target);

    document
      .querySelectorAll('cart-item-count-element')
      .forEach((element) => element.classList.toggle('hidden', target.textContent === '0'));
  }
}

customElements.define('cart-item-count', CartItemCount);
